import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import { capitalizeAndTranslateMsg } from '../../../mainUtils';
import BaseSwitch from '../../../_ui/BaseSwitch/BaseSwitch';

function ActorSwitch({
  switchValueCallback,
  label = '',
  fieldName = '',
  disabled = false,
  checked = false,
}) {
  const { t } = useTranslation();

  const [switchValue, setSwitchValue] = useState(false);

  const changeSwitch = () => {
    setSwitchValue(!switchValue);

    if (switchValueCallback) {
      switchValueCallback(!switchValue);
    }
  };

  useEffect(() => {
    setSwitchValue(checked);
  }, [checked]);

  return (
    <Form.Item
      label={capitalizeAndTranslateMsg('auth.headers.user_type', label)}
      name={fieldName}
    >
      <BaseSwitch
        checkedChildren={capitalizeAndTranslateMsg('auth.buttons.yes', 'yes')}
        unCheckedChildren={capitalizeAndTranslateMsg('auth.buttons.no', 'no')}
        checked={switchValue}
        onClick={changeSwitch}
        disabled={disabled}
      />
    </Form.Item>
  );
}

export default ActorSwitch;

ActorSwitch.propTypes = {
  switchValueCallback: PropTypes.func,
  label: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
};
